"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var Footer_1 = require("./Footer");
var LvFlowProgressBarWidget_1 = require("./progressBar/LvFlowProgressBarWidget");
var services_1 = require("@falcon/services");
var MotorProgressBarSettings_1 = require("./progressBar/MotorProgressBarSettings");
var RentersProgressBarSettings_1 = require("./progressBar/RentersProgressBarSettings");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../commonFunctions");
var JourneyNavbar_1 = require("../components/JourneyNavbar");
var MaintenanceBannerWidget_1 = require("../widgets/MaintenanceBannerWidget");
var LvFalconNavigatorWithArrowBackButtons = /** @class */ (function (_super) {
    __extends(LvFalconNavigatorWithArrowBackButtons, _super);
    function LvFalconNavigatorWithArrowBackButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.hidePageTitlesForPages = ["cancelCarCoverSummary", "cancelHomePolicySummary"];
        _this.skipDefault = function (event) {
            event.preventDefault();
        };
        _this.showProgressBar = false;
        _this.showBackground = true;
        _this.isMotorProduct = services_1.productHelper.isMotor(_this.props.interaction);
        _this.isRentersProduct = services_1.productHelper.isRenters(_this.props.interaction);
        if (_this.isMotorProduct) {
            _this.progressBarSettings = new MotorProgressBarSettings_1.MotorProgressBarSettings();
        }
        else if (_this.isRentersProduct) {
            _this.progressBarSettings = new RentersProgressBarSettings_1.RentersProgressBarSettings();
        }
        _this.clickPrev = _this.clickPrev.bind(_this);
        _this.preClickNext = _this.preClickNext.bind(_this);
        _this.clickNext = _this.clickNext.bind(_this);
        return _this;
    }
    LvFalconNavigatorWithArrowBackButtons.prototype.componentDidCatch = function (error, errorInfo) {
        this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "JRE: exception: ".concat(error.message ? error.message : "", "\n    Interaction id: ").concat(this.props.interaction._id || "-", "\n    Product: ").concat(this.props.product || "-", "\n    Process: ").concat(this.props.process || "-", "\n    Page: ").concat(this.props.page && this.props.page.pageId, "\n    ComponentStack: ").concat(errorInfo.componentStack || "-", "\n    Stack: ").concat(error.stack || "-")
        }, false).subscribe();
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.render = function () {
        var _a, _b, _c;
        return (React.createElement(React.Fragment, null,
            this.showBackground && (React.createElement("div", { className: "journey-bg" },
                React.createElement("div", null,
                    React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }),
                    React.createElement("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" })))),
            this.mapInteractionToDataLayer(),
            this.renderHeader(),
            this.renderProgressBar(),
            React.createElement("div", { className: "journey-content journey-content-arrow" },
                React.createElement("div", { className: "journey-arrow-header" },
                    React.createElement("div", { className: "journey-arrow-header-content" },
                        React.createElement(services_1.FalconNavigatorHeader, { back: {
                                html: (_a = this.renderBackButtonTop()) !== null && _a !== void 0 ? _a : undefined
                            }, title: {
                                label: (_c = (_b = this.props.page) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : "",
                                hidden: !this.props.page || !this.isTitleVisible()
                            } }))),
                React.createElement("div", { className: "journey-questions" },
                    React.createElement("div", { className: "journey-questions-body" },
                        React.createElement("div", { className: "journey-questions-body-content" },
                            this.isTitleVisible() && React.createElement(MaintenanceBannerWidget_1.MaintenanceBannerWidget, { product: this.props.product }),
                            this.props.children))),
                (this.props.page && (this.props.page.nextPage || this.props.page.prevPage)) &&
                    React.createElement("div", { className: "journey-arrow-buttons" },
                        React.createElement("div", { className: "journey-arrow-buttons-content" },
                            this.renderNextButton(),
                            this.renderBackButtonBottom()))),
            this.renderFooter()));
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.isTitleVisible = function () {
        var _a, _b;
        return (((_a = this.props.page) === null || _a === void 0 ? void 0 : _a.pageId) !== "decline")
            && (this.props.process === 'nb'
                || this.props.process.startsWith("mta")
                || this.props.process.startsWith("mtc")) && !this.hideTitleForPage((_b = this.props.page) === null || _b === void 0 ? void 0 : _b.pageId);
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.hideTitleForPage = function (pageId) {
        if (pageId) {
            return this.hidePageTitlesForPages.indexOf(pageId) > -1;
        }
        return false;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.clickPrev = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickPrev.call(this)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.engine.validate()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.preClickNext = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.target.focus();
                        return [4 /*yield*/, this.clickNext()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.clickNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickNext.call(this)];
                    case 1:
                        _c.sent();
                        if ((0, commonFunctions_1.isPageValid)(this.props.pageValidations, this.props.validations)) {
                            this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = true, _a));
                        }
                        else {
                            this.props.engine.setJourneyState((_b = {}, _b["hidePageValidationErrorMessage"] = false, _b));
                        }
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.renderBackButtonTop = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.prevPage) {
            return (React.createElement("button", { type: "button", className: "btn btn-back-journey-arrow-white", onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.clickPrev, id: "navigatorBack" }, this.props.page && this.props.page.prevPageLabel ? this.props.page.prevPageLabel : "Back"));
        }
        return null;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.renderBackButtonBottom = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.prevPage) {
            return (React.createElement("button", { type: "button", className: "btn btn-back-journey-arrow-blue", onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.clickPrev, id: "navigatorBack" }, this.props.page && this.props.page.prevPageLabel ? this.props.page.prevPageLabel : "Back"));
        }
        return null;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.renderNextButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.nextPage) {
            var cssClasses = "btn btn-primary btn-next-arrow-separate" + (this.isNextButtonEnabled() ? "" : " btn-disabled");
            return (React.createElement("button", { type: "button", className: cssClasses, onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.preClickNext, id: "navigatorNext" },
                this.props.page && this.props.page.nextPageLabel ? this.props.page.nextPageLabel : "Next",
                React.createElement("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })));
        }
        return null;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.renderProgressBar = function () {
        if (!this.showProgressBar) {
            return React.createElement(React.Fragment, null);
        }
        var percentageByPageId = this.progressBarSettings ? this.progressBarSettings.getPercentageByPageId(this.props.page.pageId) : null;
        if (percentageByPageId === null) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(LvFlowProgressBarWidget_1.default, { percentage: percentageByPageId });
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.renderHeader = function () {
        var _this = this;
        var clickLogout = function () {
            var redirectUrl = "".concat(window.location.origin, "/dashboard");
            _this.cacheManager.clearAll();
            _this.applicationGuard.logout({ redirectUri: redirectUrl });
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "journey-bg min-h-450" },
                React.createElement("div", null,
                    React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }),
                    React.createElement("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" }))),
            this.props.process !== services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_MTA && React.createElement(JourneyNavbar_1.JourneyNavbar, { logout: clickLogout })));
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.renderFooter = function () {
        return React.createElement(Footer_1.Footer, null);
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.mapInteractionToDataLayer = function () {
        if (this.props.interaction) {
            var policyHolder = this.props.interaction.policyHolder ? this.props.interaction.policyHolder : null;
            var address = policyHolder && policyHolder.address ? policyHolder.address : null;
            var factors = this.props.interaction.factors ? this.props.interaction.factors : null;
            var underwritingResult = this.props.interaction.underwritingResult && this.props.interaction.underwritingResult.length > 0 ? this.props.interaction.underwritingResult[0] : null;
            var vehicleCount = this.props.interaction.vehicles ? this.props.interaction.vehicles.length : 0;
            var isWolfProduct = services_1.productHelper.isWolfMotor(this.props.interaction);
            window.LvDataLayer = {
                screenResolution: window.innerWidth + "x" + window.innerHeight,
                pageTitle: this.props.page.title,
                partner: "lv",
                employmentStatus: policyHolder && policyHolder.employmentStatus ? this.fetchLookupValue("employmentStatus", policyHolder.employmentStatus) : null,
                maritalStatus: policyHolder && policyHolder.maritalStatus ? this.fetchLookupValue("maritalStatus", policyHolder.maritalStatus) : null,
                ukResidency: policyHolder ? policyHolder.residencyLength : null,
                ownsHome: policyHolder && policyHolder.ownsHome !== null ? (policyHolder.ownsHome ? "Yes" : "No") : null,
                claimsIndicated: policyHolder && policyHolder.hasClaims !== null ? (policyHolder.hasClaims ? "Yes" : "No") : null,
                convictionsIndicated: policyHolder && policyHolder.hasConvictions !== null ? (policyHolder.hasConvictions ? "Yes" : "No") : null,
                yearOfBirth: policyHolder && policyHolder.dateOfBirth ? this.extractYearFromDate(policyHolder.dateOfBirth) : null,
                emailAddress: policyHolder ? policyHolder.email : null,
                postCode: address ? address.outwardPostcode : null,
                numberOfDrivers: this.getNumberOfDrivers(this.props.interaction),
                totalPricePerMonth: factors ? factors.premium : null,
                priceRange: this.getPriceRange(factors),
                quoteReference: this.props.interaction._id,
                marketingPreferenceEmail: policyHolder ? (policyHolder.marketingPreferencesEmail ? "Y" : "N") : null,
                marketingPreferencePhone: policyHolder ? (policyHolder.marketingPreferencesPhone ? "Y" : "N") : null,
                marketingPreferencePost: policyHolder ? (policyHolder.marketingPreferencesPost ? "Y" : "N") : null,
                marketingPreferenceSms: policyHolder ? (policyHolder.marketingPreferencesSMS ? "Y" : "N") : null,
                policyReference: this.props.interaction.agreementNumber,
                failedUwRule: underwritingResult ? underwritingResult.objectName : null,
                vehicles: this.getVehicleData(),
                numberOfCars: vehicleCount,
                multipleCars: vehicleCount > 1 ? "Y" : "N",
                documentMethod: policyHolder && policyHolder.sendDocumentsByPost ? "Post" : "Email",
                coverTier: this.props.interaction.coverTier,
                protectedNcd: isWolfProduct && policyHolder && policyHolder.ncd ? (policyHolder.ncd.doNotDisclose ? "Y" : "N") : null
            };
        }
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.isNextButtonEnabled = function () {
        return !this.props.page.nextPageButtonCondition ||
            journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, this.props.page.nextPageButtonCondition, this.props.interaction);
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.extractYearFromDate = function (date) {
        return moment(date, moment.ISO_8601).year();
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.getNumberOfDrivers = function (interaction) {
        if (interaction.policyHolder) {
            if (interaction.additionalDrivers) {
                return interaction.additionalDrivers.length + 1;
            }
            else {
                return 1;
            }
        }
        return null;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.getPriceRange = function (factors) {
        if (factors) {
            return factors.neverLower + "-" + factors.neverHigher;
        }
        return null;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.getVehicleData = function () {
        var _this = this;
        var vehicleInfo = [];
        if (this.props.interaction.vehicles) {
            var optionalExtras_1 = this.props.interaction.optionalExtras;
            this.props.interaction.vehicles.forEach(function (vehicle) {
                var legalProtection = optionalExtras_1 ? (optionalExtras_1.motorLegalExpenses ? "Y" : "N") : null;
                var courtesyCar = optionalExtras_1 ? (optionalExtras_1.courtesyCar ? "Y" : "N") : null;
                var courtesyCarTotalLoss = _this.setValueOrNull(optionalExtras_1, function () { return _this.getYN(optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarTotalLoss); });
                var car = {
                    yearOfManufacture: vehicle.year,
                    fuelType: vehicle.fuelType ? _this.fetchLookupValue("vehicleFuelType", vehicle.fuelType) : null,
                    make: vehicle.make,
                    model: vehicle.model,
                    voluntaryExcess: vehicle.excesses ? vehicle.excesses.voluntaryExcess : null,
                    courtesyCar: courtesyCar,
                    motorLegalExpensesCost: legalProtection ? optionalExtras_1.motorLegalExpensesCost : null,
                    motorLegalExpenses: legalProtection,
                    courtesyCarCost: courtesyCar ? optionalExtras_1.courtesyCarCost : null,
                    courtesyCarTotalLoss: courtesyCarTotalLoss,
                    courtesyCarTotalLossCost: _this.setValueOrNull(courtesyCarTotalLoss, function () { return optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarTotalLossCost; }),
                    breakdownCover: optionalExtras_1 ? (optionalExtras_1.breakdownCover ? "Y" : "N") : null,
                    breakdownCoverType: optionalExtras_1 && optionalExtras_1.breakdownCoverLevel ? optionalExtras_1.breakdownCoverLevel : null,
                    courtesyCarAmount: courtesyCar ? optionalExtras_1.courtesyCarCost : null,
                    totalPricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.grossPremium : null,
                    pricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.roundedPremium : null
                };
                vehicleInfo.push(car);
            });
        }
        return vehicleInfo;
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.getYN = function (value) {
        return value ? "Y" : "N";
    };
    LvFalconNavigatorWithArrowBackButtons.prototype.setValueOrNull = function (condition, valueAccessor) {
        return condition != null ? valueAccessor() : null;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], LvFalconNavigatorWithArrowBackButtons.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], LvFalconNavigatorWithArrowBackButtons.prototype, "journeyRuntimeService", void 0);
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], LvFalconNavigatorWithArrowBackButtons.prototype, "applicationGuard", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CacheManager),
        __metadata("design:type", Object)
    ], LvFalconNavigatorWithArrowBackButtons.prototype, "cacheManager", void 0);
    return LvFalconNavigatorWithArrowBackButtons;
}(plugin_journey_1.NavigatorWidgetBase));
exports.default = LvFalconNavigatorWithArrowBackButtons;
//# sourceMappingURL=LvFalconNavigatorWithArrowBackButtons.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/navigator/LvFalconNavigatorWithArrowBackButtons.js
// module id = 749
// module chunks = 0